export default {
  Evapotranspiration: "NHP_ISRO_AET_EB_DY_",
  "et-Evapotranspiration": "NHP_ISRO_AET_EB_DY_",
  "et-Evapotranspiration-Monthly": "NHP_ISRO_AET_EB_MN_",
  "et-Evapotranspiration-Fortnightly": "NHP_ISRO_AET_EB_FN",
  "et-Evapotranspiration-Monthly750": "AET_SNPP_N_EB_MN_",
  "et-Evapotranspiration-Fortnightly750": "AET_SNPP_N_EB_FN",

  "pet-Evapotranspiration": "PET_SNPP_R_EB_DY_",
  "pet-Evapotranspiration-Monthly": "PET_SNPP_R_EB_MN_",
  "pet-Evapotranspiration-Fortnightly": "PET_SNPP_R_EB_FN",
  "pet-Evapotranspiration-Monthly750": "PET_SNPP_N_EB_MN_",
  "pet-Evapotranspiration-Fortnightly750": "PET_SNPP_N_EB_FN",

  
  "mai-Evapotranspiration": "MAI_SNPP_R_EB_DY_",
  "mai-Evapotranspiration-Monthly": "MAI_SNPP_R_EB_MN_",
  "mai-Evapotranspiration-Fortnightly": "MAI_SNPP_R_EB_FN",
  "mai-Evapotranspiration-Monthly750": "MAI_SNPP_N_EB_MN_",
  "mai-Evapotranspiration-Fortnightly750": "MAI_SNPP_N_EB_FN",

  "esi-Evapotranspiration": "ESI_SNPP_R_EB_DY_",
  "esi-Evapotranspiration-Monthly": "ESI_SNPP_R_EB_MN_",
  "esi-Evapotranspiration-Fortnightly": "ESI_SNPP_R_EB_FN",
  "esi-Evapotranspiration-Monthly750": "ESI_SNPP_N_EB_MN_",
  "esi-Evapotranspiration-Fortnightly750": "ESI_SNPP_N_EB_FN",


  Evapotranspiration_WB: "NHP_ISRO_AET_WB_3D_",
  "Soil Heat Flux": "NHP_ISRO_DSHF_",
};
